module.exports = __webpack_public_path__ + "img/Deathknight-gnome-f-70.cde24efb.gif";